export const subusers = {
  title: "Subusuarios",
  subtitle: "Creá y administrá subusuarios con acceso a tus agentes",
  newSubUser: "Nuevo Subusuario",
  noSubUsers: "No se encontraron subusuarios",
  edit: "Editar",
  delete: "Eliminar",
  name: "Nombre",
  email: "Email",
  password: "Contraseña",
  phone: "Teléfono",
  create: "Crear Subusuario",
  table: {
    title: "Nombre",
    email: "Email",
    password: "Contraseña",
    phone: "Teléfono",
    actions: "Acciones",
  },
  actions: {
    edit: "Editar",
    delete: "Eliminar",
  },
  update: "Actualizar",
  invalidEmail: "Email inválido",
  invalidEmailDescription: "Por favor, ingresá un email válido",
};
